import {
  UNSUPPORTED_INSURANCE_PLAN_MODAL,
  UNSUPPORTED_STATE_MODAL,
} from './InsurancePickerForm.constants'

export const dialogMap = {
  [UNSUPPORTED_STATE_MODAL]: {
    title: "At this time, we don't ship to your state",
    description:
      'We are working hard on the ability to ship to your state! Until then, here are a couple partners that we work with:',
  },
  [UNSUPPORTED_INSURANCE_PLAN_MODAL]: {
    titleA: 'Please enter your Insurance Carrier',
    titleB: "At this time, we don't support your plan.",
    description:
      'We are working hard to have more insurance coverage, including your plan! Until then, here is a partner that we work with:',
  },
}
